import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { Box, Button } from '@mui/material'
import Translations from 'src/@core/layouts/components/Translations'
import { useRouter } from 'next/router'
import { LandState } from 'src/@types'

interface RainsEmptyCardProp {
  landId: number
  status: LandState
}

export default function RainsEmptyCard({ landId, status }: RainsEmptyCardProp) {
  const router = useRouter()

  const handleRedirectToRains = () => {
    router.push(`/lands/details/rains/${landId}`)
  }

  return (
    <Card
      className='rains-card'
      sx={{
        minWidth: '250px',
        height: '260px',
        alignItems: 'center',
        borderRadius: '20px',
        backgroundColor: '#D9D9D9',
        paddingTop: '45px',
        paddingBottom: '45px',
        paddingRight: '13px',
        paddingLeft: '13px',
      }}
    >
      <CardContent
        className='card-medio'
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        <Box
          sx={{
            margin: 'auto',
            width: '270px',
            height: '120px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <Typography
            sx={{
              fontSize: 'clamp(16px, 10px, 25px)',
              fontWeight: '700',
              textAlign: 'center',
              color: 'rgb(120 120 120)',
              mb: 5
            }}
            className='cards-title'
          >
            <Translations text={`You haven't uploaded your rainfall history yet`} />
          </Typography>
          {status === LandState.COMPLETED ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', w: '100%', alignItems: 'center', mt: '24px' }}>
              <Button
                variant='outlined'
                sx={{
                  color: '#213D36',
                  width: '123px',
                  padding: '8px, 12px, 8px, 12px',
                  fontSize: '16px',
                  fontWeight: 700,
                  borderRadius: '30px',
                  border: '3px solid #213D36',
                  backgroundColor: 'white'
                }}
                onClick={handleRedirectToRains}
              >
                <Translations text={'Load'} />
              </Button>
            </Box>
          ) : null}
        </Box>
      </CardContent>
    </Card>
  )
}
